'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002415 from "./presto.-Agent-View$$anon$15.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dRequest$0024 from "./presto.-Agent-View$-Local-Shodo-Sign-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$14() {
  this.aw2 = null;
  this.avU = null;
  this.avV = false;
  this.aw3 = null;
  this.aw4 = false;
  this.aw7 = null;
  this.aw0 = null;
  this.aw1 = false;
  this.avW = null;
  this.avX = false;
  this.avY = null;
  this.avZ = false;
  this.aw5 = false;
  this.aw6 = false;
  this.aw2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aw7 = "LocalShodoSignRequest";
}
export { $c_Lpresto_AgentView$$anon$14 as $c_Lpresto_AgentView$$anon$14 };
$p = $c_Lpresto_AgentView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$14;
/** @constructor */
function $h_Lpresto_AgentView$$anon$14() {
}
export { $h_Lpresto_AgentView$$anon$14 as $h_Lpresto_AgentView$$anon$14 };
$h_Lpresto_AgentView$$anon$14.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aw2;
});
$p.M = (function() {
  if ((!this.avV)) {
    this.avU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.avV = true;
  }
  return this.avU;
});
$p.O = (function() {
  if ((!this.aw4)) {
    this.aw3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aw4 = true;
  }
  return this.aw3;
});
$p.E = (function() {
  return this.aw7;
});
$p.t = (function() {
  if ((!this.aw1)) {
    this.aw0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("nomeAlgoritmo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("textos", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aw1 = true;
  }
  return this.aw0;
});
$p.N = (function() {
  if ((!this.avX)) {
    this.avW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.avX = true;
  }
  return this.avW;
});
$p.Q = (function() {
  if ((!this.avZ)) {
    this.avY = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002415.$c_Lpresto_AgentView$$anon$15();
    this.avZ = true;
  }
  return this.avY;
});
$p.v = (function() {
  if ((!this.aw6)) {
    this.aw5 = false;
    this.aw6 = true;
  }
  return this.aw5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee100) => ((p) => \u03b4scrutinee100.cFn(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dSign$002dRequest$0024.$m_Lpresto_AgentView$LocalShodoSignRequest$())));
});
var $d_Lpresto_AgentView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$14, "presto.AgentView$$anon$14", ({
  DA: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$14 as $d_Lpresto_AgentView$$anon$14 };
//# sourceMappingURL=presto.-Agent-View$$anon$14.js.map
